<template>
  <div class="pageList--wrap" :style="{ padding }" :class="[{ 'tabs': isTabs }, flag]">
    <page-content-header
        v-if="isHideHeader"
        @updateSearch="onSearch"
        @updateClick="onClick"
        :title="pageTitle"
        :isPageTitle="isPageTitle"
        :isSearch="isSearch"
        :isCreate="isCreate"
        :isCreatePermissions="isCreatePermissions"
        :isException="isException"
        :textCreate="textCreate"
        :isFilterRefresh="isFilterRefresh"
        :isSettings="isSettings"
        :isInfo="isInfo"
        :infoText="infoText"
        :isBackList="isBackList"
        :send="send"
        :isSend="isSend"
        :sendText="sendText"
        :isRefresh="isRefresh"
        :isSend2="isSend2"
        :textSend2="textSend2"
        :isExport="isExport"
        :isExportPermissions="isExportPermissions"
        :isUpload="isUpload"
    ></page-content-header>
    <slot name="tabs"></slot>
    <div
        class="pageList--content"
        :class="[{ 'noPagination': pageCount === 1 }]"
    >
      <v-data-table
          @page-count="pageCount = $event"
          :page.sync="page"
          :headers="headers"
          :items="items"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :class="['pageList--table', flag]"
          :items-per-page="getItemsPerPage"
          :height="height"
          :show-select="false"
          hide-default-footer
          hide-default-header
          hide-default-body
          fixed-header
      >
        <template v-slot:header="{ props: { headers } }">
          <thead class="thead">
          <tr>
            <th
                v-for="(item, index) in headers"
                :key="index"
                :style="`width: ${ item.width || 'inherit'}`"
                :class="[
                    {'right':item.buttons && !(item.isAddAll || item.isRemoveAll) || item.links,
                     'center': (item.isAddAll || item.isRemoveAll) },
                    {'filter-active': filterClasses[item.valueFilter] || filterClassesActive(item.value)},
                    {'dense': item.dense},
                    {'lastTh': item.sticky},
                    item.value
                ]"
                class="th"
                :id="'container-'+item.value"
            >
              <field
                  v-if="item.isCheckboxAll"
                  margin="0"
                  padding="0"
                  height="24"
                  :switch-value="checkAll"
                  @updateSwitch="onCheckboxAll"
                  is-dense
                  is-checkbox
                  :indeterminate="indeterminate"
                  is-off-style
                  :is-disabled="!list.length"
              ></field>
              <div v-else class="controls">
                <sort-btn
                    v-if="item.sortable"
                    :sortDesc="sortDesc"
                    :sortBy="sortBy"
                    :data-sort="item.value"
                    @updateToggleOrder="toggleOrder"
                ></sort-btn>
                <template v-for="({ textAll, icon, margin, color }, index) in item.buttons">
                  <tool-tip
                      v-if="item.isAddAll || item.isRemoveAll"
                      :key="index"
                      :text="textAll"
                      :margin="margin"
                      content-class="left"
                  >
                    <button
                        :disabled="!(items.length)"
                        type="button"
                        @click="onHandleTable(item.isAddAll ? 'plus' : 'delete' )"
                    >
                      <svg-sprite :style="{ color }" :width="icon.w" :height="icon.h"
                                  :icon-id="icon.value"></svg-sprite>
                    </button>
                  </tool-tip>
                </template>
                <div v-if="item.text" class="theadText">{{ item.text }}</div>
                <filter-drop-down v-if="item.func" :item="item">
                  <filter-table
                      @change-sort="changeSort"
                      @create-refresh="createRefresh"
                      @filter-created="filterCreated"
                      @updateFilterListAll="onFilteredAll(item.valueFilter)"
                      :data-filter="filtersList[item.valueFilter]"
                      :defaultFilter="defaultFilter"
                      :selectedAllElements="selectedAllElements"
                      :item="item"
                      :model-filter="item.valueFilter"
                      :type-filter="item.model"
                      :filter-update="filterUpdate"
                      :refreshDate="refreshDate"
                      :labelFilter="item.text"
                      :isDisabled="isDisabled"
                      :is-disabled="filterPreloader"
                      :isRefresh="isRefresh"
                      :flag="flag"
                  ></filter-table>
                </filter-drop-down>
              </div>
            </th>
          </tr>
          </thead>
        </template>

        <template v-slot:body="{ items }">
          <tbody>
          <row-tr
              v-for="(item, index) in items"
              :flag="flag"
              :headers="headers"
              :page="page"
              :key="uniqKey(item.id)"
              :index="index"
              :indexNumber="index"
              :itemsPerPage="getItemsPerPage"
              :line="item"
              :filterClasses="filterClasses"
              :isRefresh="isRefresh"
              :checkAll="checkAll"
              :department_id="department_id"

              @updateClickButton="onClickButton($event, index)"
              @updateModEvent="onModEvent"
              @updateEdit="onEdit"
              @updateCheckboxDS="onCheckboxDS"
              @updateCounter="onCounter"
              @updateCheckOrder="onCheckOrder"
              @updatePaid="onPaid"
              @updateFile="onFile"
              @updateFieldInput="onFieldInput"
              @updateStatusSwitch="onStatusSwitch"
          ></row-tr>
<!--          @updateModal="onModal"-->
          <row-last-tr
              v-if="isLastRow"
              :headers="headers"
              :listItems="listItems"
          ></row-last-tr>
          </tbody>
        </template>
      </v-data-table>
    </div>
    <pagination
        v-if="isPag"
        :length="items.length"
        :pageCount="pageCount"
        :itemsPerPage="itemsPerPage"
        :page="page"
        :isRefresh="isRefresh"
        :isRefreshPage="isRefreshPage"
        :pages="pages"
        :background="background"
        @updatePreloader="onPreloader"
        @updatePagination="onPagination"
        @updateCountPagination="onCountPagination"
    ></pagination>
    <preloader v-if="isPreloader" :preload="isPreloader"></preloader>
  </div>
</template>

<script>

// components
import FilterTable from "@/shared/FilterTable/FilterTable";
import RowTr from "@/shared/MainTable/RowTr/RowTr";
import RowLastTr from "@/shared/MainTable/RowLastTr/RowLastTr";
import Pagination from "@/shared/Pagination/Pagination";
import PageContentHeader from "@/shared/PageContentHeader/PageContentHeader";
import Preloader from "@/shared/Preload/Preload";
import SortBtn from "@/shared/SortBtn/SortBtn";
import FilterDropDown from "@/shared/FilterDropDown/FilterDropDown";
import ToolTip from "@/shared/ToolTip/ToolTip";

// helper
import getUniqId from "@/helper/getUniqId";
import { FILTER_KEYS, PAGE } from "@/constants/constants";
import debounce from "lodash.debounce";

export default {
	name: "MainTable",
	components: {
		FilterTable,
		RowTr,
		RowLastTr,
		Pagination,
		PageContentHeader,
		Preloader,
		SortBtn,
		FilterDropDown,
		ToolTip
	},
	props: {
		department_id: Number,
		isRefreshFilters: String,
		background: String,
		// background: {
		// 	type: String,
		// 	default: () => '#22222d'
		// },
		isPagination: {
			type: Boolean,
			default: () => true
		},
		isLastRow: {
			type: Boolean,
			default: () => true
		},
		height: null,
		flag: String,
		uniqId: String,
		pageTitle: String,
		isPageTitle: {
			type: Boolean,
			default: () => true
		},
		isUpload: Boolean,
		headers: {
			type: Array,
			default: () => []
		},
		settings: Array,
		padding: {
			type: String,
			default: '10px 10px 0'
		},
		isHideHeader: {
			type: Boolean,
			default: () => true
		},
		isTabs: Boolean,
		isExport: {
			type: Boolean,
			default: () => true
		},
		isExportPermissions: Boolean,
		listItems: {
			type: Array,
			default: () => []
		},
		defaultFilter: {
			type: Object,
			default: () => ({})
		},
		filtersList: {
			type: Object,
			default: () => ({})
		},
		updateRefreshFilters: Boolean,
		isSearch: {
			type: Boolean,
			default: true
		},
		isCreate: {
			type: Boolean,
			default: true
		},
		isCreatePermissions: Boolean,
		isException: Boolean,
		textCreate: {
			type: String,
			default: 'Add new'
		},
		isFilterRefresh: {
			type: Boolean,
			default: true
		},
		isInfo: Boolean,
		infoText: {
			type: String,
			default: 'Info'
		},
		isSettings: Boolean,
		isBackList: Boolean,
		send: Boolean,
		isSend: Boolean,
		sendText: {
			type: String,
			default: 'Send'
		},
		pages: {
			type: Array,
			default: () => [ 5, 20, 50, 100, 200, 500, "All" ]
		},
		defaultSortBy: {
			type: String,
			default: ''
		},
		defaultSortDesc: {
			type: Boolean,
			default: () => false
		},
		itemsPerPageAmount: {
			type: Number,
			default: () => 20
		},
		checkAll: Boolean,
		indeterminate: Boolean,
		isSend2: [ Boolean, Array ],
		textSend2: {
			type: String,
			default: 'Send'
		},
	},
	computed: {
		getItemsPerPage() {
			return this.itemsPerPage === 'All' ? 99999999 : this.itemsPerPage;
		},
		isPag() {
			return (this.items.length && this.items.length > this.itemsPerPage) && this.isPagination;
		},
		filterClasses: {
			get() {
				return this.checkClasses;
			},
			set(arr) {
				const obj = {};
				for (const i in arr) {
					obj[i] = !!arr[i].length;
				}
				this.checkClasses = obj;
			},
		},
		items: {
			get() {
				return this.listItems;
			},
			set(arr) {
				this.listItems = arr;
			},
		},
	},
	watch: {
		uniqId(value, oldValue) {
			if (value !== oldValue) {
				this.onRefreshFilters();
			}
		},
		flag(value, oldValue) {
			if (value !== oldValue) {
				this.onRefreshFilters();
			}
		},
		updateRefreshFilters(value, oldValue) {
			if (value !== oldValue) {
				this.onRefreshFilters();
			}
		}
	},
	data() {
		return {
			isPreloader: false,
			filterPreloader: false,
			checkboxAll: [],
			itemsPerPage: 20,
			page: 1,
			pageCount: 0,
			sortBy: this.defaultSortBy,
			sortDesc: this.defaultSortDesc,
			employeeValue: '',
			valid: true,
			loading: false,
			checkItemPay: null,
			checkItemSend: null,
			filterUpdate: false,
			selectedAllElements: { key: '', id: '' },
			refreshDate: null,
			up: [],
			search: "",
			link: null,
			menu: false,
			preload: false,
			filtersMarker: {},
			checkClasses: {},
			filters: {},
			list: this.listItems,
			itemRemove: null,
			filterModList: {},
			isDisabled: false,
			lazy: false,
			preloader: false,
			snackbarSend: false,
			customersData: [],
			defaultSort: '',
			arrCheckbox: [],
			isRefresh: null,
			isRefreshPage: '',
		};
	},
	methods: {
		uniqKey(id) {
			return getUniqId() + id;
		},
		onHandleTable(value) {
			this.$emit('updateHandleTable', value);
		},
		onPaid(value) {
			this.$emit('updatePaid', value);
		},
		onFile(value) {
			this.$emit('updateFile', value);
		},
		onFieldInput(args) {
			this.$emit("updateFieldInput", args);
		},
		onStatusSwitch(args) {
			this.$emit("updateStatusSwitch", args);
		},
		onCheckOrder(id, line) {
			this.$emit('updateCheckOrder', id, line);
		},
		onCheckboxAll({ value }) {
			this.$emit('updateCheckOrders', value);
		},
		onClick(args) {
			const { flag } = args;
			if (flag === 'refresh') this.onRefreshFilters();
			if (flag === 'settings') this.$emit("updateSettings");
			if (flag === 'create') this.$emit("updateCreate");
			if (flag === 'info') this.$emit("updateInfo");
			if (flag === 'back') this.$emit("updateBack");
			if (flag === 'send') this.$emit("updateSend");
			if (flag === 'export') this.$emit("updateExport", this.filterModList);
			this.$emit('updateEvent', args);
		},
		filterClassesActive(filterKey) {
			const { filter_check_in_empty, filter_check_out_empty } = this.filterModList || {};
			return (filterKey === "check_in" && filter_check_in_empty)
          || (filterKey === "check_out" && filter_check_out_empty);
		},
		onPagination(value) {
			this.page = value;
		},
		onPreloader() {
			this.isPreloader = true;
		},
		onCountPagination(value) {
			this.itemsPerPage = value;
			this.isPreloader = false;
		},
		onRefreshFilters() {
			this.sortDesc = this.defaultSortDesc;
			this.defaultSort = false;
			this.itemsPerPage = 20;
			this.sortBy = this.defaultSortBy;
			this.refreshDate = getUniqId();
			this.page = 1;
			this.search = "";
			this.isRefresh = "";

			for (const variable in this.filterModList) {
				this.filterClasses[variable] = false;
				delete this.filterModList[variable];
			}

			if (this.flag === PAGE.WORK_ORDERS) {
				this.getFilterModList();
			} else {
				this.$emit("updateRefreshFilters", { flag: this.flag });
			}
			this.isRefresh = getUniqId();
		},
		getSortColor(sortBy, value) {
			return sortBy === value || (sortBy && value.includes(sortBy));
		},
		onCounter(values) {
			this.$emit('updateCounter', values);
		},
		onCheckboxDS(values) {
			this.$emit('updateCheckboxDS', values);
		},

		onClickButton(values, index) {
			this.$emit("updateClickButtonItemIndex", index);
			this.$emit("updateClickButton", values);
		},
		onModEvent(args) {
			this.$emit('updateModEvent', args);
		},
		// onModal(value) {
		// 	this.$emit("updateModal", value);
		// },
		onEdit(value) {
			this.$emit("updateEdit", value);
		},
		onSearch(value) {
			this.search = value;
			this.filterModList.search = value;
			const flag = this.flag;
			const type = 'post';
			const filterModList = this.filterModList;
			this.$emit("updateSearch", { flag, type, filterModList });
		},
		getFilterModList() {
			for (const key in this.filtersList) {
				this.filterModList[key] = [];
			}
			if (this.flag === PAGE.WORK_ORDERS) {
				this.sortBy = this.defaultSortBy;

				const statusSettings = this.settings.find(item => item.value === FILTER_KEYS.STATUS).settings;
				if (statusSettings) {
					this.checkClasses[FILTER_KEYS.FILTER_STATUS] = true;
					if (!this.defaultFilter) return false;
					const { filter_status } = this.defaultFilter;
					filter_status.filter(item => {
						if ((item.id !== 9) && (item.id !== 11)) this.filterModList[FILTER_KEYS.FILTER_STATUS].push(item.id);
					});
				}
				this.sendChangeSort();
			}
		},
		onFilteredAll(item) {
			this.filterCreated(item);
			this.selectedAllElements = {
				id: getUniqId(),
				key: item
			};
		},
		createRefresh(model) {
			this.filtersMarker[model] = true;
			if (!Object.values(this.filtersMarker).includes(false)) {
				this.filterUpdate = false;
				for (const i in this.filtersMarker) {
					this.filtersMarker[i] = true;
				}
			}
			this.filterClasses = this.filters;
		},
		filterCreated(model) {
			this.filtersMarker[model] = false;
		},
		changeSort({ key, value, model }) {
			switch (model) {
				case 'date':
					this.filterModList[key] = value;
					this.filterClasses[key] = !!this.filterModList[key]['from'];
					break;
				case 'number':
					this.filterModList[key] = value;
					this.filterClasses[key] = !!this.filterModList[key]['type'];
					break;
				case 'note':
					this.filterModList[key] = value;
					this.filterClasses[key] = !!this.filterModList[key].length;
					break;
				case 'options':
					this.filterModList[key] = Number(value);
					this.filterClasses[key] = !!this.filterModList[key].length;
					break;
				case 'checkbox':
					this.filterClasses[key] = Number(value);
					this.filterModList[key] = value;
					break;
				case 'list':
					this.filterModList[key] = value.map(item => item);
					this.filterClasses[key] = !!this.filterModList[key].length;
					break;
				default:
					this.filterModList[key] = value;
					this.filterClasses[key] = !!this.filterModList[key].length;
			}

			this.sendChangeSort();
		},
		sendChangeSort: debounce(function() {
			this.filterPreloader = true;
			this.isDisabled = true;

			const flag = this.flag;
			const type = 'post';
			const filterModList = this.filterModList;

			this.$emit("updateChangeSort", { flag, type, filterModList });
			this.isDisabled = false;
			this.isRefreshPage = getUniqId();
			this.filterPreloader = false;
		}, 800),
		toggleOrder(val) {
			this.defaultSort = val;
			this.sortBy = val;
			this.sortDesc = !this.sortDesc;
		}
	},
	created() {
		for (let i = 0; i < this.headers.length; i++) {
			this.filtersMarker[this.headers[i].value] = true;
			this.checkClasses[this.headers[i].value] = false;
			this.filters[this.headers[i].value] = [];
		}
	},
	mounted() {
		this.itemsPerPage = this.itemsPerPageAmount;
		this.getFilterModList();
	}
};
</script>
<style lang="scss">
@import 'mainTable';
.pageList--wrap.accountSalaryHistorySlide {
	.pagination {
		background: transparent !important;
	}
}

</style>
